import React, { useMemo } from 'react';
import { PanoramaDetails } from '../services/UploadManagementServiceTypes';
import { AHoverCircle, AHoverText } from './AframeItems';
import { AframePosition, AHoverCircleNode } from './AframeTypes';
import { CirclePosition } from './circlePosition';
import { WaypointOptions } from './TourModeModal';

const underRing: AframePosition = { x: 0, y: -0.4, z: 0 };

export const WaypointNextContent: AHoverCircleNode = (props) => (
  <AHoverText text='Next >' position={underRing} width={0.7} height={0.2} {...props} />
);

export const WaypointPreviousContent: AHoverCircleNode = (props) => (
  <AHoverText text='< Previous' position={underRing} width={1} height={0.2} {...props} />
);

const getNextOrPrevious = (
  currentPanoramaIndex: number,
  otherPanoramaIndex: number,
  totalPanoramas: number,
) => {
  const indices = [currentPanoramaIndex, otherPanoramaIndex];
  const isEdgeCase = indices.includes(0) && indices.includes(totalPanoramas - 1);
  if (totalPanoramas > 2 && isEdgeCase) {
    return currentPanoramaIndex === 0 ? WaypointPreviousContent : WaypointNextContent;
  }
  return currentPanoramaIndex < otherPanoramaIndex ? WaypointNextContent : WaypointPreviousContent;
};

export interface PanoramaViewerWaypointProps {
  currentPanoramaIndex: number;
  currentPanorama: PanoramaDetails;
  panorama: PanoramaDetails;
  panoramaIndex: number;
  waypointOption: WaypointOptions;
  goToPanorama: (index: number) => void;
  totalPanoramas: number;
}

export const PanoramaViewerWaypoint: React.FC<PanoramaViewerWaypointProps> = ({
  panorama,
  currentPanorama,
  waypointOption,
  currentPanoramaIndex,
  panoramaIndex,
  goToPanorama,
  totalPanoramas,
}) => {
  const position = useMemo(
    () => new CirclePosition(currentPanorama, panorama).calculate(),
    [currentPanorama, panorama],
  );
  const subNode =
    waypointOption === '2'
      ? getNextOrPrevious(currentPanoramaIndex, panoramaIndex, totalPanoramas)
      : undefined;
  return (
    <AHoverCircle
      faceToCamera
      onClick={() => goToPanorama(panoramaIndex)}
      position={position}
      Node={subNode}
    />
  );
};
